export default {
  methods: {
    isValidPwd(pwd) {
      return (
        this.hasLowercaseChar(pwd) &&
        this.hasUppercaseChar(pwd) &&
        this.hasDigitChar(pwd) &&
        this.hasSpecialChar(pwd) &&
        this.isValidLength(pwd)
      );
    },
    hasLowercaseChar(pwd) {
      return pwd?.match(/[a-z]/g);
    },
    hasUppercaseChar(pwd) {
      return pwd?.match(/[A-Z]/g);
    },
    hasDigitChar(pwd) {
      return pwd?.match(/[0-9]/g);
    },
    hasSpecialChar(pwd) {
      return pwd?.match(/[^a-zA-Z\d]/g);
    },
    isValidLength(pwd) {
      return pwd?.length >= 10;
    },
  },
};
